import React from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from "assets/images/svg/search_blue.svg";

interface Props {
  value?: string;
  onChange: (query: string) => void;
}

function SearchInput({ onChange, value }: Props) {
  const { t } = useTranslation("common");
  return (
    <label className="input-search" htmlFor="a">
      <input
        type="text"
        placeholder={t("search")}
        id="search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <span>
        <img src={SearchIcon} alt="search icon" />
      </span>
    </label>
  );
}

export default SearchInput;
